import { VueNodeViewRenderer } from '@tiptap/vue-3'
import MentionLink from './MentionLink.vue'
import { UserMentionSchema } from '~/tiptap/mention/mention-schema'

export const UserMention = UserMentionSchema.extend({
  addNodeView() {
    return VueNodeViewRenderer(MentionLink)
  },
})
